import { Pagination, Table } from "antd";
import { useState } from "react";

function AgreementsTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const data = [
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Terms Accepted",
      details: "Terms of Use accepted (version 1.3)",
    },
    {
      date: "Oct 15, 2024 03:34 PM",
      action: "Terms Updated",
      details: "Terms of Use updated (added new data retention policy)",
    },
    {
      date: "Oct 02, 2024 20:00 PM",
      action: "Terms Re-Accepted",
      details: "User re-accepted the Terms of Use (version 1.2)",
    },
  ];

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      sorter: (a, b) => a.action.localeCompare(b.action),
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      sorter: (a, b) => a.details.localeCompare(b.details),
    },
  ];
  return (
    <div className="agreements-table-container">
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey={(record) => record.id}
        scroll={{ y: 500 }}
        onRow={(record) => ({
          onClick: () => {
            console.log(record);
          },
        })}
      />
      <div className="pagination">
        <Pagination
          current={currentPage}
          total={data.length}
          pageSize={pageSize}
          showSizeChanger
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  );
}

export default AgreementsTable;
